export const PRODUCT_UPDATE_LIBRARY = 'PRODUCT_UPDATE_LIBRARY';
export const PRODUCT_UPDATE_INSTANTLY_CREATED = 'PRODUCT_UPDATE_INSTANTLY_CREATED';
export const PRODUCT_REMOVE_INSTANTLY_CREATED = 'PRODUCT_REMOVE_INSTANTLY_CREATED';

export const SET_LOOK_BOARDS_BY_PRODUCT = 'SET_LOOK_BOARDS_BY_PRODUCT';
export const SET_ACTIVE_PRODUCT_LB_MODAL = 'SET_ACTIVE_PRODUCT_LB_MODAL';
